module.exports = __webpack_public_path__ + "static/media/p2.43e308d4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/p2.webp
// module id = 264
// module chunks = 0